<template>
  <v-modal name="subaccount-create-edit-modal" :loading="loading" @onClose="onCloseModal">
    <h2 slot="header" v-if="type === 'edit'">
      Edit Subaccount
    </h2>
    <h2 slot="header" v-else>
      Create Subaccount
    </h2>
    <div slot="content">
      <v-form :onSubmit="validateForm" data-vv-scope="account" ref="form">
        <div slot="row">
          <v-grid>
            <div slot="gridItem" type="8">
              <b>Company Name</b>
              <v-input
                type="text"
                :class="{ 'a-input--error': errors.has('account.name') }"
                placeholder="e.g. Jo Industries"
                v-validate="'required'"
                data-vv-name="name"
                data-vv-as="name"
                v-model="account.name"
                data-vv-scope="account"
                data-test="input-account-name" />
              <v-message
                type="error"
                subtype="basic"
                v-show="errors.has('account.name')">
                <icon slot="icon" name="times"></icon>
                <span slot="text">{{ errors.first('account.name') }}</span>
              </v-message>
            </div>
            <div slot="gridItem" type="4">
              <b>Company Email</b>
              <v-input
                type="text"
                :class="{ 'a-input--error': errors.has('account.email') }"
                placeholder="e.g. jo@example.com"
                v-validate="'required|email'"
                data-vv-name="email"
                data-vv-as="email"
                v-model="account.email"
                data-vv-scope="account"
                data-test="input-account-email" />
            </div>
          </v-grid>
        </div>
        <div slot="formButtons" type="left">
          <v-button
            type="error"
            href="#"
            :action="openDeleteSubaccountModal"
            v-if="type === 'edit'"
            data-test="button-delete-user" >
            <icon name="trash" />
            <span>{{ $t('users.deleteUser') }}</span>
          </v-button>
        </div>
        <div slot="formButtons" type="right">
          <v-button
            type="cta-1"
            subtype="submit"
            data-test="save-user" >
            <icon name="check" />
            <span>Save Account</span>
          </v-button>
        </div>
      </v-form>
    </div>
  </v-modal>
</template>

<script>
import { VButton, VInput, VMessage } from '@signable/ui-kit/src/atoms/';
import {} from '@signable/ui-kit/src/molecules/';
import { VForm, VGrid, VModal } from '@signable/ui-kit/src/organisms/';

export default {
  name: 'CreateEditSubaccountModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    accountDetails: {
      type: [Object],
      required: true,
    },
    type: {
      type: [String],
      default: 'edit',
    },
    storeAction: {
      type: [String],
      required: true,
    },
  },
  components: {
    VButton,
    VInput,
    VMessage,
    VForm,
    VGrid,
    VModal,
  },
  data() {
    return {
      loading: false,
      // accountDetails: null,
    };
  },
  computed: {
    account() {
      const defaultAccount = {
        name: null,
        email: null,
      };
      return this.accountDetails || defaultAccount;
    },
  },
  methods: {
    onCloseModal() {
      const scope = this.$refs.form.$el.getAttribute('data-vv-scope');
      this.errors.clear(scope);
    },
    openDeleteSubaccountModal() {
      this.$bus.$emit('toggleModal', { name: 'subaccount-delete-modal', active: true });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store.dispatch(this.storeAction, this.account).then(() => {
            this.$bus.$emit('closeModal');
            this.loading = false;
            this.$store.dispatch('subaccounts/PAGINATE', { page: 1 }); // Reload from page 1
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
